<template>
  <div>
    <div class="absolute w-4 mt-4 right-6 flex z-10 text-gray-400">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
        <path d="M24,37L0,13.1h48L24,37z"/>
      </svg>
    </div>
    <select v-bind:value="value" class="modal-select" v-on:change="$emit('input', parseInt($event.target.value))">
      <option v-for="option in timeOptions" v-bind:value="option.value" v-bind:key="option.text">
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: function () {
        return 60
      }
    }
  },
  data () {
    return {
      selectTimes: [
        1,
        5,
        10,
        20,
        30,
        40,
        50,
        1 * 60,
        1 * 60 + 15,
        1 * 60 + 30,
        1 * 60 + 45,
        2 * 60,
        2 * 60 + 15,
        2 * 60 + 30,
        2 * 60 + 45,
        3 * 60,
        3 * 60 + 15,
        3 * 60 + 30,
        3 * 60 + 45,
        4 * 60,
        4 * 60 + 15,
        4 * 60 + 30,
        4 * 60 + 45,
        5 * 60,
        5 * 60 + 15,
        5 * 60 + 30,
        5 * 60 + 45,
        6 * 60,
        6 * 60 + 15,
        6 * 60 + 30,
        6 * 60 + 45,
        7 * 60,
        7 * 60 + 15,
        7 * 60 + 30,
        7 * 60 + 45,
        8 * 60,
        8 * 60 + 15,
        8 * 60 + 30,
        8 * 60 + 45,
        9 * 60,
        9 * 60 + 15,
        9 * 60 + 30,
        9 * 60 + 45,
        10 * 60,
        10 * 60 + 30,
        11 * 60,
        11 * 60 + 30,
        12 * 60,
        12 * 60 + 30,
        13 * 60,
        13 * 60 + 30,
        14 * 60,
        14 * 60 + 30,
        15 * 60,
        15 * 60 + 30,
        16 * 60,
        16 * 60 + 30,
        17 * 60,
        17 * 60 + 30,
        18 * 60,
        18 * 60 + 30,
        19 * 60,
        19 * 60 + 30,
        20 * 60,
        20 * 60 + 30,
        21 * 60,
        21 * 60 + 30,
        22 * 60,
        22 * 60 + 30,
        23 * 60,
        23 * 60 + 30,
      ]
    }
  },
  computed: {
    timeOptions: function () {
      const a = []
      for (var i = 0; i < this.selectTimes.length; i++) {
        a.push({
          text: (this.selectTimes[i] / 60 >= 1 ? Math.floor(this.selectTimes[i] / 60) + this.$t('tour_hour_label') : "") + (this.selectTimes[i] % 60 !== 0 ? String(this.selectTimes[i] % 60) + this.$t('tour_minute_label') : ""),
          value: String(this.selectTimes[i]),
        });
      }
      return a
    }
  }
}
</script>
